import {TextFieldConfiguration, TextFieldTypes} from './types'

export const buildTextFieldConfiguration = <T extends TextFieldTypes>(
  type: T,
  enabled: boolean,
  minLength?: number,
  maxLength?: number
): TextFieldConfiguration<T> => {
  return {
    [type]: {
      enabled,
      minLength,
      maxLength
    }
  } as TextFieldConfiguration<T>
}
